module.exports = __webpack_public_path__ + "img/grade-circle-arrow.7790bfd8.png";